import { render, staticRenderFns } from "./ModulesOverview.vue?vue&type=template&id=b2501a2c&scoped=true"
import script from "./ModulesOverview.vue?vue&type=script&lang=js"
export * from "./ModulesOverview.vue?vue&type=script&lang=js"
import style0 from "./ModulesOverview.vue?vue&type=style&index=0&id=b2501a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2501a2c",
  null
  
)

export default component.exports